/**
 * 常量配置文件
 *
 */

// 上传接口url
const apiEditorUpload = `${process.env.VUE_APP_BASE_API}/api/weditor/upload`
const apiAttachUpload = `${process.env.VUE_APP_BASE_API}/api/upload`
// 上传文件相关
const configFile = {
  fileupload_ext: "jpg,jpeg,png,doc,docx,xls,xlsx,csv,ppt,pptx,pdf,zip,rar",
  aichat_ext: "jpg,jpeg,png,txt,doc,docx,xls,xlsx,csv,ppt,pptx,pdf",
  picupload_ext: "jpg,jpeg,png,bmp,gif",
  fileupload_size: 2048,
  withCredentials: false // 富文本编辑器上传文件安全配置
}
export {
  apiEditorUpload,
  apiAttachUpload,
  configFile
}
